import {
  PlaceAutocomplete,
  PlaceIdDetail,
  ReverseGeocode,
  TypedApiRequestParams,
} from '../types';

const autocomplete = (
  input: string,
): TypedApiRequestParams<PlaceAutocomplete[]> => ({
  url: 'providers/google/place-autocomplete',
  method: 'GET',
  params: {input},
  authRequired: true,
});

const placeId = (id: string): TypedApiRequestParams<PlaceIdDetail> => ({
  url: 'providers/google/place-id',
  method: 'GET',
  params: {place_id: id},
  authRequired: true,
});

/**
 * Resolve a coordinate to a place name.
 *
 * The endpoint is gated on client identity rather than authentication, so a
 * signed-out user still gets a label — which matters, because the forecast
 * screen shows one before any account exists.
 */
const reverseGeocode = (
  latitude: number,
  longitude: number,
): TypedApiRequestParams<ReverseGeocode> => ({
  url: 'providers/google/reverse-geocode',
  method: 'GET',
  params: {latitude, longitude},
  authRequired: false,
});

export default {
  autocomplete,
  placeId,
  reverseGeocode,
};
